import * as $ from "jquery";

interface StatusAlertItem {
    css: string;
    description: string;
    url: string;
    value: string;
}

interface StatusAlertGroup {
    title: string;
    items: Array<StatusAlertItem>;
}

export class StatusAlert {
    groups: Array<StatusAlertGroup>;
    $container: JQuery;

    constructor($container: JQuery) {
        this.groups = [];
        this.$container = $container;
    }

    loadItems() {
        const self = this;
        $.ajax({
            cache: false,
            url: "/services/AlertList.ashx",
            dataType: "json",
            success: function (data: Array<StatusAlertGroup>) {
                self.groups = data;
                self.loadItemsPersonal();
            },
        });
    }

    loadItemsPersonal() {
        const self = this;
        $.ajax({
            cache: false,
            url: "/services/AlertPersonal.ashx",
            dataType: "json",
            success: function (data: Array<StatusAlertGroup>) {
                self.groups = self.groups.concat(data);
                self.displayItems();
            },
        });
    }

    displayItems() {
        let html = "";
        for (var group of this.groups) {
            html += this.appendGroupHtml(group);
        }
        this.$container.html(html);
    }

    appendGroupHtml(group: StatusAlertGroup): string {
        let html = "";
        html += "<div class='statusalert-group'>";
        html += "<div class='statusalert-title'>";
        html += group.title; // need to HTML encode
        html += "</div>";
        for (var item of group.items) {
            html += "<div class='statusalert-item ";
            html += item.css;
            html += "'>";
            html += "<div class='statusalert-value'>";
            html += "<a href='";
            html += item.url;
            html += "'>";
            html += item.value;
            html += "</a></div>";
            html += "<div class='statusalert-text'>";
            html += "<a href='";
            html += item.url;
            html += "'>";
            html += item.description;
            html += "</a></div></div>";
        }
        html += "</div>";
        return html;
    }
}
